module.exports = __webpack_public_path__ + "img/25.f7f82172.jpg";